// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { identity } from 'lodash';

// Utils
import { getElementCardRenderedWidthPx } from '../../utils/elementUtil';

// Components
import ElementImage from '../../../components/images/ElementImage';
import previewImageDropTargetDecorator from '../../dnd/elementDropTargets/previewImageDropTargetDecorator';
import ImageReplacementOverlay from '../../image/ImageReplacementOverlay';

// Constants
import { IMAGE_TYPES } from '../../../../common/media/mediaConstants';

// Styles
import './LinkImage.scss';

const enhance = previewImageDropTargetDecorator();

const LinkImage = (props) => {
    const {
        element,
        gridSize,
        isHovered,
        canDrop,
        connectFileDropTarget = identity,
        setForceCanDrop,
        isResizing,
    } = props;

    const linkData = element.getIn(['content', 'link']);
    const imageData = element.getIn(['content', 'image']);

    const widthPx = getElementCardRenderedWidthPx(props);

    const forceCanDrop = isHovered && canDrop;

    useEffect(() => {
        setForceCanDrop && setForceCanDrop(forceCanDrop);
    }, [forceCanDrop]);

    if (!linkData || !imageData || !imageData.size) return null;

    return connectFileDropTarget(
        <div className="LinkImage">
            {forceCanDrop && <ImageReplacementOverlay />}
            <ElementImage
                showBrokenIconOnError
                cropToGrid={!isResizing}
                gridSize={gridSize}
                element={element}
                imageType={IMAGE_TYPES.ELEMENT}
                widthPx={widthPx}
            />
        </div>,
    );
};

LinkImage.propTypes = {
    element: PropTypes.object,
    gridSize: PropTypes.number,
    isHovered: PropTypes.bool,
    canDrop: PropTypes.bool,
    setForceCanDrop: PropTypes.func,
    connectFileDropTarget: PropTypes.func,
    isResizing: PropTypes.bool,
};

export default enhance(LinkImage);
